import { createElement } from 'react';
import ComponentBlocksBanner from './Banner';
import ComponentBlocksFeaturedGrid from './FeaturedGrid';
import { MenuLink as ComponentMenuMenuLink, MenuDropdown as ComponentMenuDropDownMenu } from './Menu';
import ComponentInputPopupButton from './PopupButton';
import ComponentInputSearchInput from './Search';
const classes = {
  ComponentBlocksFeaturedGrid,
  ComponentBlocksBanner,
  ComponentInputPopupButton,
  ComponentInputSearchInput,
  ComponentMenuMenuLink,
  ComponentMenuDropDownMenu
};
const createComponent = ({
  __typename,
  ...item
}, index) => createElement(classes[__typename], item);
export default createComponent;